import TopNav from "../components/TopNav.jsx";
import ProductMark from "../components/ProductMark.jsx";
import FreeConsultWidget from "../components/FreeConsultWidget.jsx";

/**
 * StewardPage · /steward
 * Free forever · operations consult for verified 501(c)(3)s.
 * Grant writing, board reporting, policy drafting.
 */
export default function StewardPage() {
  return (
    <div className="min-h-screen bg-sage-bg text-sage-text sage-grain" data-testid="steward-page">
      <TopNav />
      <div className="mx-auto max-w-4xl px-4 md:px-8 py-12">
        <div className="text-[10px] uppercase tracking-[0.3em] text-sage-accent mb-3">FREE FOREVER · NON-PROFIT TIER</div>
        <div className="flex items-start gap-4 mb-4">
          <div className="text-sage-accent shrink-0"><ProductMark slug="steward" size={48} /></div>
          <h1 className="text-4xl md:text-5xl font-bold tracking-tighter uppercase">Steward</h1>
        </div>
        <p className="text-lg text-sage-muted leading-relaxed max-w-3xl mb-10 sage-prose">
          The grant writer and operations desk for non-profits. Free forever for verified 501(c)(3)s. Steward drafts the proposal, cleans the board packet, writes the annual letter, and keeps the mission legible.
        </p>

        <div className="border border-sage-border p-6 mb-10">
          <div className="text-xs uppercase tracking-[0.15em] text-sage-muted mb-3">Who it's for</div>
          <ul className="list-disc list-inside text-sm text-sage-text space-y-2 sage-prose">
            <li>Verified 501(c)(3) staff and volunteers</li>
            <li>Small non-profits without a development team</li>
            <li>Community groups drafting their first grant</li>
            <li>Anyone writing a mission statement they don't want to hate reading later</li>
          </ul>
        </div>

        <div className="grid md:grid-cols-2 gap-4 mb-10">
          <div className="border border-sage-border p-4" data-testid="steward-feature-1">
            <div className="text-sm font-bold uppercase tracking-tight text-sage-text mb-1">Grant proposal drafter</div>
            <div className="text-xs text-sage-muted sage-prose">Turn a mission and a budget line into a draft that reads like a real human wrote it — with the specifics funders want.</div>
          </div>
          <div className="border border-sage-border p-4" data-testid="steward-feature-2">
            <div className="text-sm font-bold uppercase tracking-tight text-sage-text mb-1">Board reporting</div>
            <div className="text-xs text-sage-muted sage-prose">One-page quarterly summaries in the same shape every time. Board members thank you.</div>
          </div>
          <div className="border border-sage-border p-4" data-testid="steward-feature-3">
            <div className="text-sm font-bold uppercase tracking-tight text-sage-text mb-1">Policy drafting</div>
            <div className="text-xs text-sage-muted sage-prose">Conflict-of-interest, whistleblower, document-retention — the policies auditors ask for.</div>
          </div>
          <div className="border border-sage-border p-4" data-testid="steward-feature-4">
            <div className="text-sm font-bold uppercase tracking-tight text-sage-text mb-1">Impact-letter writer</div>
            <div className="text-xs text-sage-muted sage-prose">Annual letters, thank-you notes, and donor updates — honest without being schmaltzy.</div>
          </div>
        </div>

        <div className="mb-10">
          <h2 className="text-2xl font-bold uppercase tracking-tight text-sage-text mb-3">Ask Steward — anonymous</h2>
          <FreeConsultWidget
            role="steward-nonprofit-operations"
            productSlug="steward"
            placeholder="Describe your organization (mission, size, current need) and what you'd like Steward to draft or improve."
            ctaLabel="Ask Steward"
            disclaimer="Steward is a helper, not an auditor or lawyer. It won't file for you. It won't sign for you. For anything binding, use your own counsel."
          />
        </div>

        <div className="border-t border-sage-border pt-6 text-xs text-sage-muted sage-prose">
          Steward is free forever for verified non-profits. If your organization needs the paid consult tier (with private data-room + policy library), Baker & Sage offers it in the non-profit bundle at 25% off.
        </div>
      </div>
    </div>
  );
}
